import { render } from "./BaseRadioButton.vue?vue&type=template&id=18bd3498&scoped=true"
import script from "./BaseRadioButton.vue?vue&type=script&lang=js"
export * from "./BaseRadioButton.vue?vue&type=script&lang=js"

import "./BaseRadioButton.vue?vue&type=style&index=0&id=18bd3498&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18bd3498"]])

export default __exports__